export const ESTADO_PUBLICADA = 2
export const ESTADO_PAUSADA = 3
export const ESTADO_VENCIDA = 5
